import { useLookbookWishlistContext } from '@app/components/lookbook/context/LookbookWishlistContext';
import { Button } from '@app/components/various/Button';
import { FavouritesFill, FavouritesOutline } from '@app/components/various/Icons';
import { GAProductListItemId, GAProductListItemName, mapProductToGAItem, useAmplitude, useGTM } from '@app/utils/analytics';
import { Product } from '@typings';
import { useTranslation } from 'react-i18next';

interface Props {
  productDetails: Product.Standard;
  variants: Product.Standard[];
  activeVariant: Product.Standard;
}

export const LookbookProductDetailsButton = ({ activeVariant }: Props) => {
  const { wishlist, toggleProductInWishlist } = useLookbookWishlistContext();
  const { t } = useTranslation(['common', 'lookbook']);
  const isInWishList = wishlist.has(activeVariant.product);
  const buttonProps =
    isInWishList ? ({ color: 'secondary', variant: 'bordered' } as const) : ({ color: 'primary', variant: 'solid' } as const);
  const { trackEvent } = useAmplitude();
  const { trackGTMEvent } = useGTM();
  const handleToggleInWishlist = () => {
    if (isInWishList) {
      trackEvent({ name: 'lookbookPdm.button.removeFromWishlist' });
    } else {
      trackEvent({ name: 'lookbookPdm.button.addToWishlist' });
      trackGTMEvent('add_to_wishlist', {
        ecommerce: {
          items: [
            mapProductToGAItem(activeVariant, {
              item_list_id: GAProductListItemId.Lookbook,
              item_list_name: GAProductListItemName.Lookbook,
            }),
          ],
        },
      });
    }
    toggleProductInWishlist(activeVariant.product);
  };

  return (
    <>
      <Button icon={isInWishList ? FavouritesFill : FavouritesOutline} isFluid {...buttonProps} onClick={handleToggleInWishlist}>
        {isInWishList ? t('lookbook:remove_from_wishlist') : t('lookbook:add_to_wishlist')}
      </Button>
    </>
  );
};
